<template>
  <div>
    <technicalManage-list v-show="tabType === 1" @handleShow="handleShow" :isServiceTeacher="0" />
    <technicalManage-show v-if="tabType === 2" :rowItem="rowItem" :technicalState="technicalState" :isServiceTeacher="0"  @handleShow="handleShow"/>
  </div>
</template>

<script>
import technicalManageList from './list.vue'
import technicalManageShow from './show.vue'
export default {
  components: { technicalManageList,technicalManageShow },
  data() {
    return {
      tabType: 1,
      rowItem: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(row, type) {
      this.tabType=type
      this.rowItem = { ...row }
      this.technicalState = type
    }
  }
}
</script>

<style>
</style>
